import { css } from '@emotion/react';

/** This file is just meant to be personal dev "scratch pad" for trying out rendering components etc. I found
 * this easier to set up and use than Storybook in a few instances. */
const Scratchpad = () => (
  <div />
);

export default Scratchpad;
